module.exports = __webpack_public_path__ + "fonts/mulish-v11-latin-700italic.21ea041.woff2";